// components/RoleSelect.jsx
import { useMemo, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";

/** roles: [{id, nombre}], value: rol seleccionado (obj o id), onChange(rol) */
export default function RoleSelect({
                                       roles = [],
                                       value = null,
                                       onChange,
                                       label = "Seleccione cambio de puesto",
                                       placeholder = "Seleccione cambio de puesto...",
                                       searchPlaceholder = "Buscar rol...",
                                       className = "",
                                   }) {
    const [open, setOpen] = useState(false);
    const [q, setQ] = useState("");

    const selectedLabel =
        (value && value.nombre) ||
        roles.find((r) => r.id === value)?.nombre ||
        null;

    const filtered = useMemo(() => {
        const needle = q.trim().toLowerCase();
        return needle ? roles.filter((r) => r.nombre.toLowerCase().includes(needle)) : roles;
    }, [roles, q]);

    return (
        <div className={className}>
            {label && <Form.Label className="fw-semibold">{label}</Form.Label>}
            <Dropdown show={open} onToggle={setOpen}>
                <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start" id="dropdown-rol">
                    {selectedLabel || placeholder}
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: 300, overflowY: "auto" }}>
                    <Form.Control
                        autoFocus
                        type="text"
                        placeholder={searchPlaceholder}
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        className="mb-2"
                    />
                    {filtered.map((rol) => (
                        <Dropdown.Item
                            key={rol.id}
                            onClick={() => {
                                onChange?.(rol); // devuelve el objeto {id, nombre}
                                setOpen(false);
                            }}
                        >
                            {rol.nombre}
                        </Dropdown.Item>
                    ))}
                    {filtered.length === 0 && <div className="text-muted px-2 py-1">Sin resultados</div>}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
}
